import { H4 } from "../../../../AbstractElements";
import { LightBackground } from "../../../../Constant";
import { Col } from "reactstrap";
import { LIGHT_BACKGROUND } from "../../../../Data/UiKit/HelperClasses";

export const LightBackgrounds = () => {
  return (
    <Col xl="4" sm="6">
      <div className="border-wrapper h-100 border">
        <H4 className="mb-3">{LightBackground}</H4>
        <div className="d-flex align-items-center mb-2 gap-2">
          <div className="helper-box alert-light-primary"> </div>.alert-light-primary
        </div>
        {LIGHT_BACKGROUND.map((item, index) => (
          <div className="d-flex align-items-center mb-2 gap-2" key={index}>
            <div className={`helper-box ${item}`}> </div>.{item}
          </div>
        ))}
      </div>
    </Col>
  );
};